import React, { useState } from 'react'
import List from './Components/List'
import Create from './Components/Create'
import ExcelFileUploadHandler from '../../UIComponents/ExcelFileUploadHandler';
import { useParams } from 'react-router-dom';
import { postAPI, postAPIForm, getURL } from '../../app/api';
import { store } from '../../app/store';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

export default function Questions() {
    const [is_edit, setIsEdit] = useState(false);
    const [edit_id, setEditId] = useState(0);
    const {exam_id} = useParams();
    const store_data = JSON.parse(store());
    const [FormData, setFormData] = useState({
        exam_id: exam_id
    });
    const [Error, setError] = useState([]);

    const onChangeHandler = async (API_URL, filepath, file_type) => {
        // console.log(API_URL, filepath, file_type)
        const filter = { org_id: store_data?.org_id, exam_id: exam_id, csv_file_path: filepath, csv_file_type: file_type }
        const response = await postAPI("/questions/import-csv-questions", {...filter, user: store_data});
        if (response?.status == 1) {
            toast.success('Additional charges removed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }
    return (
        <>
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-12 col-xl-12 col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Setting/Exams'; }}>
                                Back
                            </button>
                            <p className='text-right mb-0'><small class="fw-bold py-3">Dashboard<span class="text-muted fw-light"> / Questions</span> </small></p>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className='card-title mb-0'>Questions</h5>
                                <div>
                                    <div className='d-none'>
                                        <ExcelFileUploadHandler Name="import_file" Id="import_file" onChangeHandler={onChangeHandler} form_data={FormData} setFormData={setFormData} error={Error} setError={setError} Section={"Questions"} />
                                    </div>
                                    <label className='btn btn-secondary create-new btn-primary mr-1' htmlFor="import_file">
                                        <span>
                                            <i className="fa fa-file-excel me-sm-1"></i>
                                            <span className="d-none d-sm-inline-block">Excel Import</span>
                                        </span>
                                    </label>
                                <Create BTNLabel={"Add New Question"} Header={is_edit ? "Update Question" : "Create Question"} Subheader="" PopupID="Questions" is_edit={is_edit} setIsEdit={setIsEdit} edit_id={edit_id} setEditId={setEditId} />
                                </div>
                            </div>
                            <div className="card-datatable table-responsive">
                                <List PopupID="Questions" setIsEdit={setIsEdit} setEditId={setEditId} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

